// Настройки анимаций, задаваемые через URL.
// Коэффициент амплитуды: ?amp=<число> (алиас ?amplitude=<число>).
// Значение НЕ ограничивается — можно задать любое конечное число
// (в том числе 0, отрицательное или очень большое).
// Поддерживается запятая как десятичный разделитель (например ?amp=1,5).

export const AMP_PARAM = 'amp';
export const AMP_PARAM_ALIAS = 'amplitude';

export function readAmplitudeCoeff(search = window.location.search) {
  try {
    const params = new URLSearchParams(search);
    const raw = params.get(AMP_PARAM) ?? params.get(AMP_PARAM_ALIAS);
    if (raw === null || raw.trim() === '') return 1;

    const value = Number.parseFloat(raw.trim().replace(',', '.'));
    return Number.isFinite(value) ? value : 1;
  } catch (e) {
    return 1;
  }
}

// Применяет коэффициент к :root (действует на всех страницах).
// syncUrl=true — синхронизирует значение с адресной строкой.
export function applyAmplitudeCoeff(value, { syncUrl = false } = {}) {
  const coeff = Number.isFinite(value) ? value : 1;

  document.documentElement.style.setProperty('--animation-amplitude-coeff', String(coeff));

  if (syncUrl) {
    try {
      const url = new URL(window.location.href);
      url.searchParams.set(AMP_PARAM, String(coeff));
      window.history.replaceState({}, '', url);
    } catch (e) {
      // Игнорируем — URL может быть недоступен в некоторых окружениях
    }
  }

  return coeff;
}
